import {Provider} from 'react-redux';
import {renderElement} from '@Utils/root-element.util';
import type {ColorPalettePanelProps} from '@Components/color-palettes/color-palette-panel/color-palette-panel.types';
import {ColorPalettePanel} from '@Components/color-palettes/color-palette-panel/color-palette-panel';

window.PMW.mergePMW(PMW, {
  /**
   * @param {HTMLElement} containerElement
   * @param {object} opts
   * @param {function} [opts.onColorPaletteSelect]
   * @param {ColorPaletteInfo|null} [opts.appliedColorPalette]
   * @param {function} [opts.goToTopHandler]
   * @param {ColorPaletteInfo|null} [opts.initiallyAppliedColorPalette]
   * @param {string} [opts.colorPaletteAppliedEvent]
   */
  renderColorPalettePanel(containerElement: HTMLElement, opts: ColorPalettePanelProps) {
    renderElement(
      containerElement,
      <Provider store={window.PMW.redux.store}>
        <ColorPalettePanel {...opts} />
      </Provider>
    );
  },
});
